export default __webpack_public_path__ + "static/media/933.727e12a6.png";